import React from 'react';
import { ShieldCheckIcon, ZapIcon, InfinityIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { images } from '../../data/offer';
export function HeroSection() {
  return <header className="relative w-full bg-navy-900" data-id="element-215" data-mp="219l27922y8h3">
      <div className="bg-flame px-4 py-2.5 text-center" data-id="element-216" data-mp="21cflgx9cxn8x">
        <p className="font-display text-base font-bold uppercase tracking-wide text-white sm:text-lg" data-id="element-217" data-mp="1x7prjdy9eiqn">
          Exclusive Launch Offer · 6 Volumes + 5 Bonuses for Only $27
        </p>
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-8 px-5 pb-16 pt-10 lg:grid-cols-[1.05fr_1fr] lg:gap-12 lg:pb-24 lg:pt-16" data-id="element-218" data-mp="1nhwqh6vqtm0n">
        <div className="text-center lg:text-left" data-id="element-219" data-mp="1ihs97en0gn9d">
          <p className="font-display text-lg font-bold uppercase tracking-[0.14em] text-brand" data-id="element-220" data-mp="1dljnfieb5vt8">Low Back Pain Assessment Blueprint™</p>
          <h1 className="mt-3 text-balance font-display text-[2.9rem] font-black uppercase leading-[0.92] text-white sm:text-6xl lg:text-7xl" data-id="element-221" data-mp="19idj4garaepe">
            Assess Low Back Pain With a <span className="text-brand" data-id="element-222" data-mp="31n3236na7vgn">Clearer Clinical Framework</span>
          </h1>

          <img src={images.mockup} alt="Low Back Pain Assessment Blueprint — 6 volumes collection" className="mx-auto mt-8 w-full max-w-md lg:hidden" data-id="element-223" data-mp="36f4a2gdf300v" />

          <p className="mt-6 text-lg leading-relaxed text-slate-300 sm:text-xl" data-id="element-224" data-mp="2wo9ole7zw4gh">
            A practical, step-by-step educational system designed to help physiotherapists organize their initial assessment, recognize
            concerning findings, structure their examination, and develop more consistent clinical reasoning.
          </p>

          <div className="mt-6 inline-flex flex-wrap items-center justify-center gap-x-2 rounded-xl bg-navy-800 px-4 py-3 ring-1 ring-brand/30 lg:justify-start" data-id="element-225" data-mp="3bdo0asz1mxz1">
            <span className="font-display text-xl font-extrabold uppercase text-white" data-id="element-226" data-mp="1zxqwxzqgkbia">6 Comprehensive Volumes</span>
            <span className="font-display text-xl font-extrabold text-flame" data-id="element-227" data-mp="24yn2siude7qc">+</span>
            <span className="font-display text-xl font-extrabold uppercase text-white" data-id="element-228" data-mp="agln6j0r7slx">5 Specialized Clinical Resources</span>
          </div>

          <p className="mt-5 text-base text-slate-400" data-id="element-229" data-mp="5kn1j36t8op7">
            Developed by <span className="font-semibold text-white" data-id="element-230" data-mp="qis8da2o4ky">Dr. Ryan Carter</span> for physiotherapists who want a clearer approach to
            evaluating patients with low back pain.
          </p>

          <div className="lg:[&>div]:mx-0" data-id="element-231" data-mp="3nxchky92bbyo">
            <CtaButton id="first-cta" label="Get the Complete Blueprint" tone="dark" sub="One-time payment of $27" data-id="element-232" data-mp="3ixged186vok6" />
          </div>

          <ul className="mt-5 flex flex-col items-center gap-2 text-sm font-medium text-slate-300 sm:flex-row sm:justify-center lg:justify-start" data-id="element-233" data-mp="3dxlp1242b718">
            <li className="flex items-center gap-1.5" data-id="element-234" data-mp="39yv0vkhkqzq9">
              <ZapIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-235" data-mp="1c5z51kil8ce9" /> Instant digital access
            </li>
            <li className="flex items-center gap-1.5" data-id="element-236" data-mp="186qa4cbta8h4">
              <InfinityIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-237" data-mp="2q3a5nqaibvr3" /> Lifetime access to files
            </li>
            <li className="flex items-center gap-1.5" data-id="element-238" data-mp="2v1bn66sabn0g">
              <ShieldCheckIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-239" data-mp="2uzs82jid7i09" /> 7-day money-back guarantee
            </li>
          </ul>
        </div>

        <div className="hidden lg:block" data-id="element-240" data-mp="33tdn83yfz1a7">
          <img src={images.mockup} alt="Low Back Pain Assessment Blueprint — 6 volumes collection" className="w-full" data-id="element-241" data-mp="33w9krr6dnny4" />
        </div>
      </div>
    </header>;
}